/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Deliverable_DashboardInputs */



/**
* | output |
* | --- |
* | "A dashboard" |
*
* @param {Agent_Builder_Deliverable_DashboardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_deliverable_dashboard = /** @type {((inputs?: Agent_Builder_Deliverable_DashboardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Deliverable_DashboardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Dashboard")
	return /** @type {LocalizedString} */ ("A dashboard")
});